import React from 'react';

// Shared state constants
export const itemState = {
	Open: 'Open',
	Closed: 'Closed',
	ForcedOpen: 'ForcedOpen',
	ForcedClosed: 'ForcedClosed',
};

// Simple matcher to mirror `matchString`
const match = (table) => (key) => table[key];

export function Accordion({ children }) {
	return <div className='border-border-tertiary rounded-tl-md rounded-tr-md border'>{children}</div>;
}

export function AccordionItem({ title, state, onToggle, children, statusBorder = true, icon = false }) {
	const nextState = match({
		Open: itemState.ForcedClosed,
		ForcedOpen: itemState.Closed,
		Closed: itemState.ForcedOpen,
		ForcedClosed: itemState.Open,
	});

	const onClick = () => onToggle(state, nextState(state));

	// Add this helper next to your other helpers
	const leftBorderClass = (state, enabled) =>
		enabled
			? match({
					Open: 'border-l-4 first:rounded-tl-md [border-left-color:theme(colors.slate.400)]',
					Closed: 'border-l-4 first:rounded-tl-md [border-left-color:theme(colors.sky.900)]',
					ForcedOpen: 'border-l-4 first:rounded-tl-md [border-left-color:theme(colors.emerald.600)]',
					ForcedClosed: 'border-l-4 first:rounded-tl-md [border-left-color:theme(colors.red.500)]',
			  })(state)
			: '';

	return match({
		Open: (
			<>
				<button
					onClick={onClick}
					className={`bg-surface-tertiary hover:bg-surface-hover border-border-tertiary flex w-full cursor-pointer items-center justify-between border-t-1 border-b-1 border-solid px-4 py-2 text-left font-medium first:border-t-0 last:border-b-0 ${leftBorderClass(
						state,
						statusBorder,
					)}`}
				>
					{title}
					{icon && <i className='ri-arrow-up-s-line' size={16} />}
				</button>
				<OpenContent>{children}</OpenContent>
			</>
		),
		Closed: (
			<>
				<button
					onClick={onClick}
					className={`bg-surface-muted hover:bg-surface-hover border-border-tertiary flex w-full cursor-pointer items-center justify-between border-t-1 border-b-1 border-solid px-4 py-2 text-left font-medium first:border-t-0 last:border-b-0 ${leftBorderClass(
						state,
						statusBorder,
					)}`}
				>
					{title}
					{icon && <i className='ri-arrow-down-s-line' size={16} />}
				</button>
				<ClosedContent>{children}</ClosedContent>
			</>
		),
		ForcedOpen: (
			<>
				<button
					onClick={onClick}
					className={`bg-surface-tertiary hover:bg-surface-hover border-border-tertiary flex w-full cursor-pointer items-center justify-between border-t-1 border-b-1 border-solid px-4 py-2 text-left font-medium first:border-t-0 last:border-b-0 ${leftBorderClass(
						state,
						statusBorder,
					)}`}
				>
					{title}
					{icon && <i className='ri-arrow-up-s-line' size={16} />}
				</button>
				<OpenContent>{children}</OpenContent>
			</>
		),
		ForcedClosed: (
			<>
				<button
					onClick={onClick}
					className={`bg-surface-muted hover:bg-surface-hover border-border-tertiary flex w-full cursor-pointer items-center justify-between border-t-1 border-b-1 border-solid px-4 py-2 text-left font-medium first:border-t-0 last:border-b-0 ${leftBorderClass(
						state,
						statusBorder,
					)}`}
				>
					{title}
					{icon && <i className='ri-arrow-down-s-line' size={16} />}
				</button>
				<ClosedContent>{children}</ClosedContent>
			</>
		),
	})(state);
}

function OpenContent({ children }) {
	return (
		<div className='bg-surface-primary overflow-hidden'>
			<div className='p-4'>{children}</div>
		</div>
	);
}

function ClosedContent() {
	return <></>;
}
